import {SEASONS} from '../constants/Constants'
export const getAcademicYear = (date) => {
  if (!date) return null; // <-- important

  const year = new Date(date).getFullYear();
  if (Number.isNaN(year)) return null; // defensive

  return `${year - 1}/${String(year).slice(2)}`;
};


export const getUniqueAcademicYears = (seriesList = []) => {
  const academicYears = new Set();

  seriesList.forEach((session) => {
    const { visitStartDate, userEndDate } = session;

    const startYear = getAcademicYear(visitStartDate);
    const endYear = getAcademicYear(userEndDate);

    if (startYear) academicYears.add(startYear);
    if (endYear) academicYears.add(endYear);
  });

  return Array.from(academicYears).sort(); // will be ["2025/26", "2026/27"]
};


export const getSeason = (dateStr) => {
  const date = new Date(dateStr);
  const month = date.getMonth() + 1;
  const day = date.getDate();

  if ((month === 1 && day >= 1) || (month === 2 && day <= 27)) return SEASONS?.SPRING;
  if (month === 3 || month === 4 || (month === 5 && day <= 31)) return SEASONS?.SUMMER;
  if (month === 11 || (month === 12 && day <= 31)) return SEASONS?.SPRING;
  if (month === 2 && day > 27) return SEASONS?.WINTER; // For Winter overflow into Feb
  return "";
};
